module.exports = __webpack_public_path__ + "img/profile_dialer.6049e7d2.png";